"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const logo_1 = require("@components/logo");
const React = __importStar(require("react"));
require("./styles.scss");
const burger_menu_1 = require("@components/burger-menu");
const nav_menu_1 = require("@components/nav-menu");
const Header = () => {
    return (React.createElement("header", { className: "c-header" },
        React.createElement("div", null,
            React.createElement(logo_1.Logo, null)),
        React.createElement("div", null,
            React.createElement(burger_menu_1.BurgerMenu, null),
            React.createElement(nav_menu_1.NavMenu, null))));
};
exports.Header = Header;
